import AddIcon from '../../../../assets/add.svg?react';
import styles from './FJSocialItem.module.less';
import FJLocalStore from '@src/store/FJLocalStore';

interface Props {
    type: string;
    icon: React.ReactNode;
    onClick: (type: string) => void;
}

const FJSocialItem = ({ type, icon, onClick }: Props) => {
    return (
        <div className={styles.box} onClick={() => onClick(type)}>
            <div className={styles.platformInfo}>
                {icon}
                <p className={styles.title}>{FJLocalStore._(type)}</p>
            </div>
            <AddIcon />
        </div>
    );
};

export default FJSocialItem;
